import { SectionLabel } from "./Reveal";
import { WhatsAppButton, AuditButton } from "./CTA";

export default function PageHero({ eyebrow, title, line, testid = "page", withCtas = false }) {
  return (
    <section className="relative overflow-hidden border-b border-line">
      <div className="absolute -left-32 top-0 -z-10 h-96 w-96 rounded-full bg-myrtle/15 blur-[120px]" aria-hidden="true" />
      <div className="mx-auto max-w-7xl px-6 pb-16 pt-36 lg:px-10 lg:pb-20 lg:pt-44">
        {eyebrow && <SectionLabel>{eyebrow}</SectionLabel>}
        <h1 className="max-w-4xl font-batangas text-4xl leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-testid={`${testid}-headline`}>
          {title}
        </h1>
        {line && <p className="mt-5 max-w-2xl text-base text-mut md:text-lg" data-testid={`${testid}-line`}>{line}</p>}
        {withCtas && (
          <div className="mt-8 flex flex-wrap gap-4">
            <WhatsAppButton testid={`${testid}-whatsapp`} />
            <AuditButton testid={`${testid}-audit`} />
          </div>
        )}
      </div>
    </section>
  );
}
